import UdeskLocales from 'UdeskLocales';
import Udesk from 'Udesk';
import AdminUserGroupsDetailTemplate from '../detail/template';

export default class AdminUserGroupsEditRoute extends AdminUserGroupsDetailTemplate {
    model() {
        let params = Object.assign(
            {},
            this.props.match.params,
            Object.fromEntries(new URLSearchParams(this.props.location.search))
        );
        let modelPromise = new Promise((resolve, reject) => {
            Udesk.ajax.get(Udesk.business.apiPath.concatApiPath(`/userGroup/${params.id}`, this.props.sdkOptions)).then(
                resp => {
                    resolve(resp.data);
                },
                reason => {
                    Udesk.ui.notify.error(
                        reason.errorMsg || UdeskLocales.current.business.userGroup.loadUserGroupListError
                    );
                    reject(reason);
                }
            );
        });
        return {
            userGroup: modelPromise
        };
    }
}
